// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__tD71f","errorLogs":"EditorFooter_errorLogs__30rlc"};